import ParameterValue from './ParameterValue';
import moment from 'moment';

export default class MemberClassification {

    constructor() {
        this.notice = '';
    }

    static fromData(data) {
        if (!data) {
            return;
        }

        let memberClassification = new MemberClassification();
        memberClassification.id = data.id;
        memberClassification.notice = data.notice;
        memberClassification.start = data.start;
        memberClassification.end = data.end;

        memberClassification.parameterValue = ParameterValue.fromData(data.parameterValue.data);

        return memberClassification;
    }

    getStartMomentObject() {
        return moment(this.start, 'DD.MM.YYYY');
    }

    getEndMomentObject() {
        return moment(this.end, 'DD.MM.YYYY');
    }

    isEmpty() {
        return !this.start && !this.end && !this.notice && !this.parameterValue;
    }

    isValid() {
        if (!this.parameterValue) {
            return false;
        }
        if (!this.start) {
            return false;
        }


        if (!this.isValidDateRange()) {
            return false;
        }

        return true;
    }

    isValidDateRange() {
        if (!this.start) {
            return true;
        }
        if (!this.end) {
            return true;
        }

        return this.getEndMomentObject() >= this.getStartMomentObject();
    }

    serialize() {
        return {
            startDate: this.start,
            endDate: this.end,
            notice: this.notice,
            classificationId: this.parameterValue.id,
        };
    }
}
